import React from 'react';
import PhoneInput, {
  Props as PhoneInputProps,
} from 'core/components/PhoneInput';
import {
  useFormContext,
} from 'react-hook-form';
import {
  normalizePhoneNumber,
} from 'pages/Dashboard/utils/helper';

type Props = PhoneInputProps & {
  fieldKey: string;
};

export default function PhoneInputWrapper({
  fieldKey,
  value,
  onChange,
  ...props
}: Props) {
  const { setValue } = useFormContext();

  return (
    <PhoneInput
      {...props}
      value={value}
      onChange={(newValue) => {
        const existingValue = normalizePhoneNumber(String(value ?? ''));
        const newNormalizedValue = normalizePhoneNumber(newValue?.toString() ?? '');
        if (existingValue !== newNormalizedValue) {
          onChange(newValue?.toString() ?? '');
        } else {
          setValue(fieldKey, newValue, {
            shouldDirty: false,
          });
        }
      }}
    />
  );
}
